import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface GtmEvent {
  event: string;
  [key: string]: any;
}

export enum GtmEventType {
  ONBOARDING_START = 'onboarding_start',
  ONBOARDING_STEP = 'onboarding_step',
  ONBOARDING_COMPLETE = 'onboarding_complete',
  ONBOARDING_ABANDONED = 'onboarding_abandoned',
  BUTTON_CLICK = 'button_click',
  FORM_SUBMISSION = 'form_submission',
  SIGN_UP = 'sign_up',
  DEMO_SCHEDULED = 'demo_scheduled'
}

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  private readonly renderer: Renderer2;
  private scriptInitialized = false;
  private readonly isProd = environment.NAME === 'production';

  constructor(
    private readonly rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  init(): void {
    if (!this.isProd || this.scriptInitialized) {
      return;
    }

    const gtmId = (environment as any).GTM_ID ?? 'GTM-MC85VV6V';
    const script = this.renderer.createElement('script');

    if (!script) {
      return;
    }

    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    this.renderer.appendChild(this.document.head, script);
    this.scriptInitialized = true;
  }

  private push(event: GtmEvent): void {
    (window as any).dataLayer = (window as any).dataLayer ?? [];
    (window as any).dataLayer.push(event);
  }

  trackEvent(event: GtmEventType | string, data: Record<string, any> = {}): void {
    if (!this.isProd) {
      return;
    }

    this.init();
    this.push({ event, ...data });
  }
}
